import {onMounted, ref} from 'vue';

export function useDelayedMount(count = 0) {
    const isMounted = ref(false);

    onMounted(() => {
        setTimeout(() => {
            isMounted.value = true;
        }, count);
    });

    return {
        isMounted,
    };
}
